<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3 mb-5">Money</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-form ref="moneyForm" v-model="valid" lazy-validation>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="ma-3"
                v-model="date"
                v-bind="attrs"
                label="Date"
                readonly
                required
                :rules="[() => !!date || 'Date is required']"
                v-on="on"
                ><v-icon small slot="prepend">
                  mdi-calendar
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="dateMenu = false">
            </v-date-picker>
          </v-menu>
          <v-combobox
            class="ma-3"
            label="Spend Category"
            required
            :rules="rulesSpendCategory"
            small-chips
            deletable-chips
            :items="itemsSpendCategory"
            v-model="selectedSpendCategory"
          >
            <v-icon small slot="prepend">
              mdi-shape-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Vendor"
            required
            :rules="rulesVendor"
            small-chips
            deletable-chips
            :items="itemsVendor"
            v-model="selectedVendor"
          >
            <v-icon small slot="prepend">
              mdi-office-building
            </v-icon>
          </v-combobox>
          <v-text-field
            class="ma-3"
            type="number"
            v-model="amount"
            label="Amount"
            prefix="$"
            required
            :rules="rulesAmount"
          >
            <v-icon small slot="prepend">
              mdi-cash-usd-outline
            </v-icon>
          </v-text-field>
          <v-combobox
            class="ma-3"
            label="Select Tags"
            small-chips
            multiple
            deletable-chips
            :items="itemsTags"
            v-model="tags"
          >
            <v-icon small slot="prepend">
              mdi-tag-multiple
            </v-icon>
          </v-combobox>
          <v-textarea
            class="ma-3"
            label="Description"
            rows="2"
            v-model.lazy="description"
            ><v-icon small slot="prepend">
              mdi-text
            </v-icon>
          </v-textarea>
          <v-combobox
            class="ma-3"
            label="Transaction Type"
            required
            :rules="rulesTransactionType"
            small-chips
            deletable-chips
            :items="itemsTransactionType"
            v-model="selectedTransactionType"
          >
            <v-icon small slot="prepend">
              mdi-wallet-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Pay Source"
            small-chips
            deletable-chips
            :items="itemsAccount"
            v-model="selectedPaySource"
          >
            <v-icon small slot="prepend">
              mdi-credit-card-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Pay Method"
            required
            :rules="rulesPayMethod"
            small-chips
            deletable-chips
            :items="itemsPayMethod"
            v-model="selectedPayMethod"
          >
            <v-icon small slot="prepend">
              mdi-account-cash-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Receipt"
            small-chips
            deletable-chips
            :items="itemsReceipt"
            v-model="receipt"
          >
            <v-icon small slot="prepend">
              mdi-receipt
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Trip"
            small-chips
            deletable-chips
            :items="itemsTrip"
            v-model="trip"
          >
            <v-icon small slot="prepend">
              mdi-map-marker-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Pay Sink"
            small-chips
            deletable-chips
            :items="itemsAccount"
            v-model="paySink"
          >
            <v-icon small slot="prepend">
              mdi-map-marker-outline
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Tax Category"
            small-chips
            deletable-chips
            :items="itemsTaxCategory"
            v-model="taxCategory"
          >
            <v-icon small slot="prepend">
              mdi-book-open-outline
            </v-icon>
          </v-combobox>
          <v-switch class="ma-3" v-model="business" flat small label="Business">
            <v-icon small slot="prepend">
              mdi-briefcase-outline
            </v-icon>
          </v-switch>
        </v-form>
        <v-row class="justify-center">
          <v-btn
            class="mx-3"
            small
            fab
            color="secondary"
            :disabled="!valid"
            @click="upsertMoneyRecord"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-snackbar
          v-model="snackbarModel"
          bottom
          :color="snackbarColor"
          :timeout="snackbarTimeout"
        >
          {{ snackbarText }}
          <v-btn dark text @click="snackbarModel = false">
            Close
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapState, mapActions } from "vuex";
import getsheetobj from "@/mixins/getsheetobj";

export default {
  name: "Money",
  mixins: [getsheetobj],
  data: () => ({}),
  watch: {
    tags(val, prev) {
      if (!val || !prev) return;
      if (val.length === prev.length) return;

      this.tags = val.map((tag) => {
        // Check if tag is new
        if (typeof tag === "string" && !this.itemsTags.includes(tag)) {
          // create a new row for the tag
          const id = this.sheetsObj["tag"].maxId + 1;
          const uuid = uuidv4();
          const newTag = tag;
          const params = {
            spreadsheetId: this.sheetId,
            valueInputOption: "RAW",
            range: "tag",
            insertDataOption: "INSERT_ROWS",
          };
          const valueRangeBody = {
            majorDimension: "ROWS",
            values: [[id, uuid, newTag]],
          };
          // update the sheet
          this.$gapi.getGapiClient().then((gapi) => {
            gapi.client.sheets.spreadsheets.values
              .append(params, valueRangeBody)
              .then(() => {
                // fecth the updated sheets
                this.getEditFormFields(this.sheetId, this.allSheets);
              });
          });
        }
        // if not new, simply return the tag
        return tag;
      });
    },
    selectedVendor() {
      // Check if selectedVendor is new
      if (
        typeof this.selectedVendor === "string" && // type is a string
        !this.itemsVendor.includes(this.selectedVendor) && // not already in the list
        this.selectedVendor !== "" // when the form is reset, it creates an empty row in Vendor
      ) {
        // create a new row for the vendor
        const id = this.sheetsObj["vendor"].maxId + 1;
        const uuid = uuidv4();
        const newVendor = this.selectedVendor;
        const params = {
          spreadsheetId: this.sheetId,
          valueInputOption: "RAW",
          range: "vendor",
          insertDataOption: "INSERT_ROWS",
        };
        const valueRangeBody = {
          majorDimension: "ROWS",
          values: [[id, uuid, newVendor]],
        };
        // update the sheet
        this.$gapi.getGapiClient().then((gapi) => {
          gapi.client.sheets.spreadsheets.values
            .append(params, valueRangeBody)
            .then(() => {
              // fecth the updated sheets
              this.getEditFormFields(this.sheetId, this.allSheets);
            });
        });
      }
      // if not new, simply return the vendor
      return this.selectedVendor;
    },
    trip() {
      // Check if trip is new, and not empty and not already in the tripList
      if (
        typeof this.trip === "string" &&
        this.trip !== "" &&
        !this.itemsTrip.includes(this.trip)
      ) {
        // create a new row for the trip
        const id = this.sheetsObj["trip"].maxId + 1;
        const uuid = uuidv4();
        const newTrip = this.trip;
        const params = {
          spreadsheetId: this.sheetId,
          valueInputOption: "RAW",
          range: "trip",
          insertDataOption: "INSERT_ROWS",
        };
        const valueRangeBody = {
          majorDimension: "ROWS",
          values: [[id, uuid, newTrip]],
        };
        if (this.isAuthenticated) {
          // update the sheet
          this.$gapi.getGapiClient().then((gapi) => {
            gapi.client.sheets.spreadsheets.values
              .append(params, valueRangeBody)
              .then(() => {
                // fecth the updated sheets
                this.getEditFormFields(this.sheetId, this.allSheets);
              });
          });
        }
      }
      // if not new, simply return the trip
      return this.trip;
    },
  },
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.auth.isAuthenticated,
      sheetId: (state) => state.sheet.sheetId,
      allSheets: (state) => state.sheet.allSheets,
      rulesSpendCategory: (state) => state.money.spendCategory.rules,
      itemsSpendCategory: (state) => state.edit.lists.spendCategory,
      rulesVendor: (state) => state.money.vendor.rules,
      itemsVendor: (state) => state.edit.lists.vendor,
      rulesAmount: (state) => state.money.amount.rules,
      itemsTags: (state) => state.edit.lists.tag,
      rulesTransactionType: (state) => state.money.transactionType.rules,
      itemsTransactionType: (state) => state.edit.lists.transactionType,
      rulesPaySource: (state) => state.money.paySource.rules,
      itemsAccount: (state) => state.edit.lists.account,
      rulesPayMethod: (state) => state.money.payMethod.rules,
      itemsPayMethod: (state) => state.edit.lists.payMethod,
      itemsReceipt: (state) => state.edit.lists.receipt,
      itemsTrip: (state) => state.edit.lists.trip,
      itemsTaxCategory: (state) => state.edit.lists.taxCategory,
      snackbarText: (state) => state.money.snackbar.text,
      snackbarColor: (state) => state.money.snackbar.color,
      snackbarTimeout: (state) => state.money.snackbar.timeout,
      moneySheet: (state) => state.money.moneySheet,
      sheetsObj: (state) => state.sheet.sheetsObj,
    }),
    valid: {
      get() {
        return this.$store.state.money.valid;
      },
      set(value) {
        const payload = {
          state: "valid",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    date: {
      get() {
        return this.$store.state.money.date.date;
      },
      set(value) {
        const payload = {
          state: "date",
          field: "date",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    dateMenu: {
      get() {
        return this.$store.state.money.date.menu;
      },
      set(value) {
        const payload = {
          state: "date",
          field: "menu",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    selectedSpendCategory: {
      get() {
        return this.$store.state.money.spendCategory.selected;
      },
      set(value) {
        const payload = {
          state: "spendCategory",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    selectedVendor: {
      get() {
        return this.$store.state.money.vendor.selected;
      },
      set(value) {
        const payload = {
          state: "vendor",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    amount: {
      get() {
        return this.$store.state.money.amount.value;
      },
      set(value) {
        const payload = {
          state: "amount",
          field: "value",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    tags: {
      get() {
        return this.$store.state.money.tags;
      },
      set(value) {
        const payload = {
          state: "tags",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    description: {
      get() {
        return this.$store.state.money.description;
      },
      set(value) {
        const payload = {
          state: "description",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    selectedTransactionType: {
      get() {
        return this.$store.state.money.transactionType.selected;
      },
      set(value) {
        const payload = {
          state: "transactionType",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    selectedPaySource: {
      get() {
        return this.$store.state.money.paySource.selected;
      },
      set(value) {
        const payload = {
          state: "paySource",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    selectedPayMethod: {
      get() {
        return this.$store.state.money.payMethod.selected;
      },
      set(value) {
        const payload = {
          state: "payMethod",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    receipt: {
      get() {
        return this.$store.state.money.receipt;
      },
      set(value) {
        const payload = {
          state: "receipt",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    trip: {
      get() {
        return this.$store.state.money.trip;
      },
      set(value) {
        const payload = {
          state: "trip",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    paySink: {
      get() {
        return this.$store.state.money.paySink;
      },
      set(value) {
        const payload = {
          state: "paySink",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    taxCategory: {
      get() {
        return this.$store.state.money.taxCategory;
      },
      set(value) {
        const payload = {
          state: "taxCategory",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    business: {
      get() {
        return this.$store.state.money.business;
      },
      set(value) {
        const payload = {
          state: "business",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
    snackbarModel: {
      get() {
        return this.$store.state.money.snackbar.model;
      },
      set(value) {
        const payload = {
          state: "snackbar",
          field: "model",
          value: value,
        };
        this.$store.dispatch("money/updateMoneyState", payload);
      },
    },
  },
  methods: {
    ...mapActions({
      updateSheetsObjAct: "sheet/updateSheetsObj",
    }),
    async upsertMoneyRecord() {
      if (this.$refs.moneyForm.validate()) {
        // Create the money record i.e. sheet row
        const moneyRecord = this.createMoneyRecord();
        // Update row
        if (this.isAuthenticated) {
          try {
            let snackbarText;
            if (moneyRecord.newRecord) {
              this.insertMoneyRecord(moneyRecord);
              snackbarText = `New record created!`;
            } else {
              this.updateEditRecord(moneyRecord);
              snackbarText = `Money record updated!`;
            }
            // get snackbar
            const snackbarColor = "secondary";
            this.getSnackbar(snackbarText, snackbarColor);
            // reset form
            this.clearMoneyForm();
          } catch (err) {
            console.error(err);
          }
        }
      } else {
        console.log("form is not valid and add button pushed");
      }
    },
    createMoneyRecord() {
      let row = [];
      let tagsString;
      let id;
      let uuid;
      let newRecord;
      let rowNumber;
      let range;

      // Create a string from tags
      if (this.tags) {
        tagsString = this.tags.toString();
      } else {
        tagsString = "";
      }

      if (this.id && this.uuid) {
        id = this.id;
        uuid = this.uuid;
        newRecord = false;
      } else {
        id = this.sheetsObj[this.moneySheet].maxId + 1;
        uuid = uuidv4();
        newRecord = true;
      }
      // Create a money row
      if (this.selectedPaySource) {
        let newAmount = parseFloat((parseFloat(this.amount) * 1).toFixed(2));
        row.push([
          id,
          uuid,
          this.date,
          this.selectedSpendCategory,
          this.selectedVendor,
          this.selectedTransactionType,
          tagsString,
          this.description,
          this.selectedPaySource,
          this.selectedPayMethod,
          this.receipt,
          this.trip,
          this.taxCategory,
          this.business,
          newAmount,
        ]);
      }

      if (this.selectedPaySource && this.paySink) {
        let newAmount = parseFloat((parseFloat(this.amount) * -1).toFixed(2));
        row.push([
          id + 1,
          uuidv4(),
          this.date,
          this.selectedSpendCategory,
          this.selectedVendor,
          this.selectedTransactionType,
          tagsString,
          this.description,
          this.paySink,
          this.selectedPayMethod,
          this.receipt,
          this.trip,
          this.taxCategory,
          this.business,
          newAmount,
        ]);
      }

      if (!this.selectedPaySource && this.paySink) {
        let newAmount = parseFloat((parseFloat(this.amount) * -1).toFixed(2));
        row.push([
          id,
          uuidv4(),
          this.date,
          this.selectedSpendCategory,
          this.selectedVendor,
          this.selectedTransactionType,
          tagsString,
          this.description,
          this.paySink,
          this.selectedPayMethod,
          this.receipt,
          this.trip,
          this.taxCategory,
          this.business,
          newAmount,
        ]);
      }

      if (!newRecord) {
        // find the index to get the row number => rowNumber = index +1
        rowNumber =
          this.sheetsObj[this.moneySheet].data.findIndex(
            (row) => row.id === this.id
          ) + 1;
        // create a range for the sheet to be updates => tag!A20 (row number)
        range = this.moneySheet + "!A" + rowNumber;
      } else {
        range = this.moneySheet;
      }
      console.log(range, row, newRecord);
      return { row: row, range: range, newRecord: newRecord };
    },
    async insertMoneyRecord(moneyRecord) {
      const range = this.moneySheet;
      const gapic = await this.$gapi.getGapiClient(); // init client
      const params = {
        spreadsheetId: this.sheetId,
        valueInputOption: "RAW",
        range: range,
        insertDataOption: "INSERT_ROWS",
      };
      const valueRangeBody = {
        majorDimension: "ROWS",
        values: moneyRecord.row,
      };
      await gapic.client.sheets.spreadsheets.values.append(
        params,
        valueRangeBody
      );
      await this.getEditFormFields(this.sheetId, this.allSheets);
      this.getAllSheetsObj(this.sheetId, this.allSheets);
    },
    clearMoneyForm() {
      this.$refs.moneyForm.resetValidation();
      this.$store.dispatch("money/updateMoneyState", {
        state: "date",
        field: "date",
        value: new Date(new Date().setHours(12, 59, 0, 0))
          .toISOString()
          .substr(0, 10),
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "spendCategory",
        field: "selected",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "vendor",
        field: "selected",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "amount",
        field: "value",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "description",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "tags",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "transactionType",
        field: "selected",
        value: "spend",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "paySource",
        field: "selected",
        value: "chaseFreedom",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "payMethod",
        field: "selected",
        value: "in person",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "receipt",
        value: "pic",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "trip",
        value: "sf",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "paySink",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "taxCategory",
        value: "",
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "business",
        value: false,
      });
    },
    getSnackbar(snackbarText, snackbarColor) {
      this.$store.dispatch("money/updateMoneyState", {
        state: "snackbar",
        field: "text",
        value: snackbarText,
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "snackbar",
        field: "color",
        value: snackbarColor,
      });
      this.$store.dispatch("money/updateMoneyState", {
        state: "snackbar",
        field: "model",
        value: true,
      });
    },
  },
  mounted() {
    this.getEditFormFields(this.sheetId, this.allSheets);
    if (!this.sheetsObj[this.moneySheet]) {
      this.getAllSheetsObj(this.sheetId, this.allSheets);
    }
  },
};
</script>
<style scoped>
.v-input__icon--append .v-icon {
  color: blue;
}
</style>
